import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

import {
  HealthActionTypes,
  ActionHealthInit,
  ActionBasicHealthSubmit,
  ActionBasicHealthSubmitSuccess,
  ActionBasicHealthSubmitError,
} from './types';
import HealthService from './effects';
import { APIError, ErrorResponse } from '../../helpers/types';
import { Health } from '../../models/health';
import { PayloadUserProfile, CreateProfileResult } from '../../models/profile';

export const dispatchActionHealthInit = (payload: Health): ActionHealthInit => {
  return {
    type: HealthActionTypes.ACTION_HEALTH_INIT,
    payload,
  };
};

export const dispatchBasicHealthSubmit = (payload: PayloadUserProfile): ActionBasicHealthSubmit => {
  return {
    type: HealthActionTypes.ACTION_BASIC_HEALTH_SUBMIT,
    payload,
  };
};

export const dispatchBasicHealthSubmitSuccess = (payload: CreateProfileResult): ActionBasicHealthSubmitSuccess => {
  return {
    type: HealthActionTypes.ACTION_BASIC_HEALTH_SUBMIT_SUCCESS,
    payload,
  };
};

export const dispatchBasicHealthSubmitError = (e: APIError): ActionBasicHealthSubmitError => {
  return {
    type: HealthActionTypes.ACTION_BASIC_HEALTH_SUBMIT_ERROR,
    error: e,
  };
};
// Action Creators
export const actionSaveBasicHealth = (payload: PayloadUserProfile) => {
  return (dispatch: ThunkDispatch<any, any, AnyAction>) => {
    dispatch(dispatchBasicHealthSubmit(payload));
    return HealthService.saveBasicProfileHealth(payload).then((result: CreateProfileResult) => {
      return dispatch(dispatchBasicHealthSubmitSuccess(result));
    }).catch((e: ErrorResponse) => {
      return dispatch(dispatchBasicHealthSubmitError(e.response));
    });
  };
};